import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../../common/rosetta_formatted_message';
import { CaretUp, Minus, Plus } from '../../common/fa_icons';

const moreInfoIcon = (active) =>
  React.createElement(
    active
      ? Minus
      : Plus
  );

const MoreInfoButton = ({ active, handleClick }) => (
  <div className="more-info" onClick={handleClick}>
    <button className="info-button">
      <RosettaFormattedMessage parentFilename={__filename}
        id="text"
        description="Message that appears on video series expand/collapse button"
        defaultMessage="Episode Info"
      />
      {moreInfoIcon(active)}
    </button>
    <div className="info-description">
      <CaretUp />
      <RosettaFormattedMessage parentFilename={__filename}
        id="description"
        description='Message that describes the "More Info" functionality'
        defaultMessage="See more about this Episode"
      />
    </div>
  </div>
);

MoreInfoButton.propTypes = {
  active: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired
};

export default MoreInfoButton;
